import type { Integration } from '../types';
import { IntegrationTokenName } from '../domains/api';

export const mixpanel: Integration = {
  slug: 'mixpanel',
  icon: 'mixpanel',
  name: 'integrations:mixpanel.integrations-page.title',
  provider: 'integrations:card.hotjar',
  tokenName: IntegrationTokenName.Mixpanel,
  actionLabel: {
    sendEvents: 'integrations:mixpanel.integrations-page.send-events',
  },
  description: 'integrations:mixpanel.integrations-page.description',
  descriptionLarge: 'integrations:mixpanel.integrations-page.description-large',
  resources: [
    {
      copy: 'integrations:mixpanel.integrations-page.key-benefits',
      url: 'https://www.hotjar.com/integrations/mixpanel',
      icon: 'page_full',
    },
    {
      copy: 'integrations:mixpanel.integrations-page.using-with-hotjar',
      url: '/articles/12944624288023',
      icon: 'page_full',
    },
  ],
  images: [],
  videoUrl: null,
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
  isBeta: false,
};
